import { render } from "./Sponsor.vue?vue&type=template&id=db531a58&scoped=true"
import script from "./Sponsor.vue?vue&type=script&lang=js"
export * from "./Sponsor.vue?vue&type=script&lang=js"

import "./Sponsor.vue?vue&type=style&index=0&id=db531a58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-db531a58"

export default script